import React from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { invoiceAgentsStyles } from '../styles/invoiceAgentsStyles';

const FooterButtons = ({
  selected,
  buttons,
  receivedData,
  createAgentLoading,
  handleBackButton,
  validateAndProceed,
  setAgenNamePopUp,
  backDisabled
}) => {
  const isEditMode = !!receivedData?.steps;
  return (
    <Box sx={invoiceAgentsStyles.footer}>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {!isEditMode && (
          <Button
            onClick={handleBackButton}
            variant="outlined"
            sx={invoiceAgentsStyles.footerBackButton}
            startIcon={<ArrowBack />}
            disabled={backDisabled}
          >
            Back
          </Button>
        )}

        {selected === "Review" ? null : (
          <Button
            onClick={() => {
              if (selected === "Output") {
                setAgenNamePopUp(true);
              } else {
                validateAndProceed();
              }
            }}
            variant="outlined"
            sx={invoiceAgentsStyles.footerSaveButton}
            endIcon={isEditMode ? null : <ArrowForward />}
          >
            {createAgentLoading ? (
              <CircularProgress size={24} sx={invoiceAgentsStyles.loadingSpinner} />
            ) : (
              <Typography sx={invoiceAgentsStyles.saveText}>
                {selected === "Review"
                  ? "Run"
                  : selected === "Output"
                  ? "Next"
                  : isEditMode
                  ? 'Update'
                  : "Next"}
              </Typography>
            )}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default FooterButtons;
